import { NumericFormat } from 'react-number-format';
import FieldValidationError from './FieldValidationError';

/**
 * Input de valor monetário reutilizável.
 *
 * Encapsula a máscara pt-BR (ponto de milhar e vírgula decimal, ex.: 1.234,56) e o prefixo
 * "R$" opcional, para não repetir essa configuração em cada tela.
 *
 * WHY: entrega no onChange o valor numérico já "limpo" (string sem separador de milhar e com
 * ponto como decimal, ex.: "1234.56") para casar com convertStringToStringDouble no submit e
 * com o backend. O segundo argumento traz o objeto completo do react-number-format (floatValue,
 * formattedValue) para quem precisar.
 *
 * O terceiro argumento diz de onde veio a mudança: `source` é "event" quando o usuário digitou e
 * "prop" quando o valor chegou pela prop. A biblioteca chama onValueChange também no segundo
 * caso, sempre que a formatação muda o valor recebido; quem trata o onChange como edição do
 * usuário precisa separar os dois.
 */
const InputMoney = (props) => {
    const { className, currency = false, onChange, error, ...rest } = props;

    return (
        <>
            <NumericFormat
                className={"form-control input-default " + (className || '')}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                valueIsNumericString
                placeholder={currency ? 'R$ 0,00' : '0,00'}
                prefix={currency ? 'R$ ' : undefined}
                fixedDecimalScale={currency}
                onValueChange={(values, sourceInfo) => onChange && onChange(values.value, values, sourceInfo)}
                {...rest}
            />
            <FieldValidationError error={error} />
        </>
    );
}

export default InputMoney;
